import { Skeleton } from "@mui/material";
import React from "react";

const PerfilSkeleton = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <div style={{ position: "relative" }}>
        <Skeleton variant="rounded" width="100%" height={95} />
        <div
          style={{
            position: "absolute",
            zIndex: 10,
            top: 48,
            left: 32,
          }}
        >
          <Skeleton variant="circular" width={190} height={190} />
        </div>
      </div>

      <div style={{ position: "relative" }}>
        <Skeleton variant="rounded" width="100%" height={425} />

        <FloatingSkeleton top={30} left={250} width={300} height={30} />
        <FloatingSkeleton top={80} left={250} width={400} height={180} />
        <FloatingSkeleton bottom={20} left={20} width={630} height={120} />
        <FloatingSkeleton top={20} right={20} width={300} height={150} />
        <FloatingSkeleton top={180} right={20} width={300} height={200} />
      </div>
    </div>
  );
};

const FloatingSkeleton = ({
  top,
  left,
  bottom,
  right,
  width,
  height,
}: {
  top?: number;
  left?: number;
  bottom?: number;
  right?: number;
  width: number;
  height: number;
}) => (
  <div
    style={{
      position: "absolute",
      zIndex: 10,
      top,
      left,
      bottom,
      right,
    }}
  >
    <Skeleton variant="rounded" width={width} height={height} />
  </div>
);

export default PerfilSkeleton;
